import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { LessorAreaMakerDto, LessorInfoDto, SecurityClassificationDto } from '@cradua/data';
import Swal from 'sweetalert2';

@Component({
  selector: 'cradua-survey-area-table',
  templateUrl: './survey-area-table.component.html',
  styleUrls: ['./survey-area-table.component.scss']
})
export class SurveyAreaTableComponent implements OnChanges {

  @Input() lessorAreaMakers: LessorAreaMakerDto[];
  @Input() selectedLessorInfo: LessorInfoDto;

  @Output() emitEdit = new EventEmitter<any>();
  lessorAreaMakerArrayForm: FormGroup;
  selectedIndex = null;
  filteredDelete = [];

  constructor(private fb: FormBuilder) { }

  ngOnChanges(): void {
    this.lessorAreaMakerArrayForm = this.fb.group({LessorAreaMaker: this.fb.array([])});
    this.filterAreaMaker(this.selectedLessorInfo);

  }

  filterAreaMaker(selectedLessorInfo: LessorInfoDto) {
    const filteredLessorAreaMaker = this.lessorAreaMakers.filter(item => item.AddressBookId === selectedLessorInfo.id);
    if(filteredLessorAreaMaker != null && filteredLessorAreaMaker.length) {
      this.setLessorAreaMaker(filteredLessorAreaMaker);
    }
  }


  get lessorAreaMakerFormArray() {
    return this.lessorAreaMakerArrayForm.get('LessorAreaMaker') as FormArray;
  }

  onEdit(value, index) {
    this.selectedIndex = index;
    value['index'] = index;
    this.emitEdit.emit(value);
  }


  setLessorAreaMaker(lessorAreaMakers: LessorAreaMakerDto[]) {
    lessorAreaMakers.forEach(lessor => {
      this.lessorAreaMakerFormArray.push(this.fb.group({
      LessorAreaMakerDesc: lessor.LessorAreaMakerDesc,
      LessorAreaMakerEasting: lessor.LessorAreaMakerEasting,
      LessorAreaMakerNorthing: lessor.LessorAreaMakerNorthing,
      LessorAreaMakerRemarks: lessor.LessorAreaMakerRemarks,
      PobLatitudeDegree: lessor.PobLatitudeDegree,
      PobLatitudeMin: lessor.PobLatitudeMin,
      PobLatitudeSec: lessor.PobLatitudeSec,
      PobLongitudeDegree: lessor.PobLongitudeDegree,
      PobLongitudeMin: lessor.PobLongitudeMin,
      PobLongitudeSec: lessor.PobLongitudeSec,
      AddressBookId: lessor.AddressBookId,
      LandTitleId: lessor.LandTitleId,
      id: lessor.id


      }));
    });
  }


  addLessorAreaMaker(lessor: LessorAreaMakerDto) {
  this.lessorAreaMakerFormArray.insert(0, this.fb.group({
      LessorAreaMakerDesc: lessor.LessorAreaMakerDesc,
      LessorAreaMakerEasting: lessor.LessorAreaMakerEasting,
      LessorAreaMakerNorthing: lessor.LessorAreaMakerNorthing,
      LessorAreaMakerRemarks: lessor.LessorAreaMakerRemarks,
      PobLatitudeDegree: lessor.PobLatitudeDegree,
      PobLatitudeMin: lessor.PobLatitudeMin,
      PobLatitudeSec: lessor.PobLatitudeSec,
      PobLongitudeDegree: lessor.PobLongitudeDegree,
      PobLongitudeMin: lessor.PobLongitudeMin,
      PobLongitudeSec: lessor.PobLongitudeSec,
      AddressBookId: this.selectedLessorInfo.id,
      LandTitleId: this.selectedLessorInfo.LandTitleId

      }));
  }


  onDelete(value, index: number) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        // this.dispatchDelete.emit(id);
        this.lessorAreaMakerFormArray.removeAt(index);
        if(value.id != null) {
          this.filteredDelete.push(value.id);
        }
        Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your imaginary file is safe :)', 'error');
      }
    });
  }






}
